import { I18n } from '@calendly/i18n';
import { BatchControls, BatchAction } from '@calendly/table';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectedEventTypesSelector, selectedEventTypeIdsSelector, resetSelectedEventTypes } from './slice';
const batchControlsWithGapCss = "bf4h643";
const BatchControlsWithGap = forwardRef((props, ref) => <BatchControls ref={ref} {...props} className={classNames(batchControlsWithGapCss, props.className)} />);
export const EventSelectionControls = ({
  userId,
  createBookingVerificationSettings,
  deleteBookingVerificationSettings,
  refetchEventTypeSettings
}) => {
  const dispatch = useDispatch();
  const selectedEventTypes = useSelector(selectedEventTypesSelector);
  const selectedEventTypeIds = useSelector(selectedEventTypeIdsSelector);
  const eventTypeUuids = Object.keys(selectedEventTypes);
  const eventTypeIds = Object.keys(selectedEventTypeIds);
  const handleClose = () => {
    dispatch(resetSelectedEventTypes());
  };
  const handleAction = async (mutationFn, params) => {
    await mutationFn(params);
    refetchEventTypeSettings();
    handleClose();
  };
  return <div>
      {eventTypeIds.length > 0 && <BatchControlsWithGap onClose={handleClose}>
          <BatchAction onClick={() => handleAction(createBookingVerificationSettings, {
        userId,
        eventTypeUuids,
        eventTypeIds
      })}>
            {I18n.t('booking.email_verification.enable_events')}
          </BatchAction>
          <BatchAction onClick={() => handleAction(deleteBookingVerificationSettings, {
        userId,
        eventTypeUuids,
        eventTypeIds
      })}>
            {I18n.t('booking.email_verification.disable_events')}
          </BatchAction>
          {I18n.t('booking.email_verification.events_selected', {
        count: eventTypeIds.length
      })}
        </BatchControlsWithGap>}
    </div>;
};

require("./batch_controls.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./batch_controls.js");